// soccer_admin/src/App.js
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Cards from './pages/Cards';
import Leagues from './pages/Leagues';
import Matches from './pages/Matches';
import SupportMessages from './pages/SupportMessages';
import API from './services/api';
import SendNotification from './pages/SendNotification';
import SeasonManagement from './pages/SeasonManagement';
import Maintenance from './pages/Maintenance';
import SponsorshipRequests from './pages/SponsorshipRequests';
import PremiumNameRequests from './pages/PremiumNameRequests';
import ErrorLogs from './pages/ErrorLogs';


// Global interceptor (كما هو)

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAdmin = async () => {
      try {
        await API.get('/admin/stats/users');
        setAuthenticated(true);
      } catch (err) {
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };
    verifyAdmin();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white text-xl animate-pulse">Loading Admin Panel...</div>
      </div>
    );
  }

  if (!authenticated) {
    return <Login setAuthenticated={setAuthenticated} />;
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="cards" element={<Cards />} />
        <Route path="leagues" element={<Leagues />} />
        <Route path="matches" element={<Matches />} />
        <Route path="support" element={<SupportMessages />} />
        <Route path="notifications" element={<SendNotification />} />
        <Route path="seasons" element={<SeasonManagement />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="sponsorship" element={<SponsorshipRequests />} />
        <Route path="premium-names" element={<PremiumNameRequests />} />
        <Route path="errors" element={<ErrorLogs />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

export default App;